module.exports = __webpack_public_path__ + "img/userLogo.1b4eb361.png";